import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import { environment } from '../../environments/environment';
import { SampleDataType } from 'user.interface';
import { UserStore } from 'user.store';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(
    protected translate: TranslateService,
    protected userStore: UserStore
  ) { }

  public async determineUserLanguage(): Promise<SampleDataType> {
    // Setup fallback language
    this.translate.setDefaultLang(environment.fallbackLocale);
    // Do we have an exact match for language support?
    let supportedDeviceLanguage = environment.locales.find(lang => lang.code === navigator.language);
    // Check if this app supports a similar dialect to the user's primary language
    supportedDeviceLanguage ??= environment.locales.find(
      lang => lang.code.indexOf(navigator.language.split('-')[0]) === 0
    );
    // Persist active language to state
    this.userStore.updateUser({ locale: supportedDeviceLanguage ? supportedDeviceLanguage.code : environment.fallbackLocale });
    // Configure dayjs with the language preference
    (dayjs).locale(this.userStore.locale);

    // Set the language to display to the user
    return this.translate.use(this.userStore.locale).toPromise();
  }

  public getCurrentLanguage(): string {
    return this.translate.currentLang;
  }
}
